export default __webpack_public_path__ + "static/media/landscape-promo-hm.6df0abbf.mp4";